export default "/images/amazon_web_services__page_heading.png";